import { Form, type FormItemProps, Input as AntdInput, type InputProps as AntdInputProps } from 'antd';

import type { Ii18nLabel } from '@/types/common';
import { getTranslatedString } from '@/utils';

import { getFormItemLabel } from './utils';

interface InputProps extends FormItemProps, AntdInputProps, Partial<Ii18nLabel> {
  name: string;
  children?: any;
  onReset?: any;
  /** Translated `Form.Item` `extra` hint (preferred over `extra` when using i18n keys). */
  i18nExtra?: string;
}

export const Input = ({
  name,
  label,
  i18nLabel,
  rules,
  disabled,
  type = 'text',
  i18nExtra,
  extra,
  ...props
}: InputProps) => {
  const fieldLabel = getFormItemLabel(i18nLabel, label);
  const extraNode = extra ?? (i18nExtra ? getTranslatedString(i18nExtra) : undefined);

  return (
    <Form.Item {...props} name={name} label={fieldLabel} rules={rules} extra={extraNode}>
      <AntdInput disabled={disabled} type={type} />
    </Form.Item>
  );
};
